import * as sonbp from "sonbp";
import * as ifbase from "../base";
import * as constants from "./constants";
export * as constants from "./constants";

/* ============================================================
 * 共通関数
 * ============================================================ */
export module util {

	/**
	 * 現在の処理モードで操作可能なレイヤーを返す
	 */
	export function getActiveLayer(ifdto: ifbase.ifDto): sonbp.object.layer {

		let layerType: string;
		switch (ifdto.procMode) {
			case ifbase.constants.MODE_PHOTO_REGIST:
			case ifbase.constants.MODE_PHOTO_REPLACE:
			case ifbase.constants.MODE_PHOTO_MANI:
				layerType = ifbase.constants.LTYPE_PHOTO;
				break;

			//case ifbase.constants.MODE_COMMENT_MANI:
			//	layerType = ifbase.constants.LTYPE_FREE;
			//	break;

			case ifbase.constants.MODE_GREETING_MANI:
				layerType = ifbase.constants.LTYPE_FREE;
				break;

			case ifbase.constants.MODE_SENDER_MANI:
				layerType = ifbase.constants.LTYPE_SENDER;
				break;

			case ifbase.constants.MODE_STAMP_MANI:
			case ifbase.constants.MODE_MYSTAMP_MANI:
			case ifbase.constants.MODE_FONTGENIC_MANI:
				layerType = ifbase.constants.LTYPE_STAMP;
				break;

			default:
				throw new Error("[sonbpIf-getActiveLayer] Invalid procMode.[" + ifdto.procMode + "]");
				break;
		}

		return getLayer(ifdto, layerType)?.layer;
	}


	/**
	 * 現在の処理モードが期待値となっているかをチェックする
	 */
	export function chkNowMode(ifdto: ifbase.ifDto, modes: string[]): void {
		if (modes.indexOf(  ifdto.procMode) < 0) {
			throw new Error("procMode is not expected. exp=" + modes + ", act=" + ifdto.procMode);
		}
	}

	/**
	 * 指定されたタイプのレイヤーを返す
	 */
	export function getLayer(ifdto: ifbase.ifDto, layerType: string): { idx: number, layer: sonbp.object.layer } {

		let layers = ifdto.bpView._om._doc.pages[0].layers;
		for (let i = 0; i < layers.length; i++) {
			if (layers[i].info.vendor_property.ffpsc?.layer_type == layerType) {
				return { idx: i, layer: layers[i] };
			}
		}

		return null;
	}

	/**
	 * items配下の全アイテムを再帰的に抽出して返す。
	 * condを指定すると条件付きで抽出できる。
	 */
	export function getItems(items: sonbp.object.baseItem[], cond?: (item: sonbp.object.baseItem) => boolean): sonbp.object.baseItem[] {

		let res: sonbp.object.baseItem[] = [];

		for (let i = 0; i < items.length; i++) {

			if (items[i].type == "group") {
				if (cond && cond(items[i]))
					res.push(items[i]);
				else
					res.concat(getItems((<sonbp.object.groupItem>items[i]).childs, cond));
			} else {
				if (cond == undefined || cond(items[i])) {
					res.push(items[i]);
				}
			}
		}

		return res;
	}

	/**
	 * スタンプorマイスタンプor手書きスタンプ判定
	 */
	export function chkIsStamp(item: sonbp.object.baseItem): boolean {

		return item.info.vendor_property.ffpsc?.item_type == constants.ITYPE_STAMP_IMG
			|| item.info.vendor_property.ffpsc?.item_type == constants.ITYPE_MYSTAMP_IMG
			|| item.info.vendor_property.ffpsc?.item_type == constants.ITYPE_FONTGENIC_IMG;
	}

	/**
	 * 画像枠判定
	 */
	export function chkIsPhotobox(item: sonbp.object.baseItem): boolean {
		return item.info.vendor_property.ffpsc?.item_type == constants.ITYPE_PHOTO_BOX;
	}

	/**
	 * テキストアイテム判定
	 */
	export function chkIsText(item: sonbp.object.baseItem): boolean {

		return item.info.vendor_property.ffpsc?.item_type == constants.ITYPE_GREETING_TXT
			//|| item.info.vendor_property.ffpsc?.item_type == constants.ITYPE_COMMENT_TXT
			|| item.info.vendor_property.ffpsc?.item_type == constants.ITYPE_SENDER_TXT;
	}

	/**
	 * SPモードでの写真操作中かを判定
	 */
	export function chkIsPhotoManiInSP(ifdto: ifbase.ifDto): boolean {

		return ifdto.client == ifbase.constants.CLIENT_SP
			&& ifdto.procMode == ifbase.constants.MODE_PHOTO_MANI
	}

	/**
	 * ファイルキーに対するリソースキーを返す。
	 * マッピング情報はキャッシュする。
	 */
	export function getResouseKey(ifdto: ifbase.ifDto, file_key: string): sonbp.type.promise {

		return new sonbp.type.promise((resolve, reject) => {

			//画像のリソースキー取得
			let resInfos = ifdto.fileKeyCache.filter(d => d.FileKey == file_key);
			if (resInfos.length > 0) {

				resolve(resInfos[0]);
			} else {

				//無ければ登録
				let prepareUniqueId = sonbp.util.js.uuid();
				sonbp.util.api.getImageKey(ifdto.token, ifdto.bpView._accessToken, ifdto.bpView._editToken, file_key, "", prepareUniqueId).then((d) => {

					if (prepareUniqueId != d.uniqueId) {
						reject(new Error("unmatch uniqueId. pre=" + prepareUniqueId + ", res=" + d.uniqueId));
						return;
					}

					let resInfo = {
						UniqueId: d.uniqueId,
						FileKey: file_key,
						ResourceKey: d.res.ret["resource-key"],
						Subtype: d.res.ret.subtype,
						Width: d.res.ret.width,
						Height: d.res.ret.height,
						FileId: undefined,
						orgWidth: undefined,
						orgHeight: undefined
					};

					ifdto.fileKeyCache.push(resInfo);

					resolve(resInfo);

				}).catch(e => {
					reject(e);

				});
			}
		});
	}

	/**
	 * ファイルキーに対するリソースキーを返す。
	 * 画像ファイル読込完了まで待つ。
	 */
	export function getResouseKeyAsync(ifdto: ifbase.ifDto, file_key: string): sonbp.type.promise {

		return new sonbp.type.promise((resolve, reject) => {

			getResouseKey(ifdto, file_key).then(resInfo => {

				let imgData = ifdto.bpView._cm.getImg(resInfo.ResourceKey);

				sonbp.util.js.loopSleep(ifdto.bpView._eff.triggerCnt, ifdto.bpView._eff.triggerInterval,
					function () {
						try {
							if (imgData.status == 2) {

								resolve(resInfo);
								return false;
							}
							return true;
						} catch (e) {
							reject(e);
							return false;
						}
					},
					"",
					function () {
						reject("image loading loop out.");
					});

			}).catch(e => {
				reject(e);
			});
		});
	}

	/**
	 * 表示サイズ調整
	 * 指定された pageAreaSize に短辺フィットするように表示サイズを変更する
	 */
	export function autoScale(ifdto: ifbase.ifDto, pageAreaSize?: number, pivot?: number): boolean {

		ifdto.pageAreaSize = pageAreaSize;

		let v = ifdto.bpView;

		if (!pageAreaSize) {
			//サイズ未指定なら全体表示
			return sonbp.tool.scale.allScale(v);
		}

		try {
			// 表示スケールレート決定
			let contSize = (v._dm as any).getPagesSize([0]) as sonbp.type.point;
			let wR = pageAreaSize / contSize.x;
			let hR = pageAreaSize / contSize.y;
			let tR = hR;
			if (wR < hR) tR = wR;
			let nextScale = v._dm.baseScaleRate * tR;

			// 小数点第3位以下は切り捨て
			if (v._exp.onlyIntegerOfScale) {
				nextScale = sonbp.util.js.floor(nextScale, 2, 0.01);
			}

			var nextPoint = v._dm.getInitialDrawPoint(v._dm.pageIdxs, nextScale, pivot || sonbp.constant.pivot.CENTER_MIDDLE);

			v._dm.scaleRate = nextScale;
			v._dm.drawPoint = nextPoint;
			v._dm.reDraw();

			return true;
		} catch (e) {
			return sonbp.util.bp.andErrorNotice(false, v, "EXCEPTION", null, e);
		}
	}

	/**
	 * 表示サイズ調整（SPモード）
	 * キャンバスに破線表示用のパディング確保するように表示サイズを変更する
	 */
	export function autoScaleSP(ifdto: ifbase.ifDto): boolean {

		let v = ifdto.bpView;
		const pad = ifbase.constants.SP_PHOTO_MANI_PADDING;

		try {
			//View領域のサイズ
			let vrect = v._dm.getFixedViewRect();

			// 表示スケールレート決定
			let contSize = (v._dm as any).getPagesSize([0]) as sonbp.type.point;
			let wR = vrect.width / (contSize.x + pad);
			let hR = vrect.height / (contSize.y + pad);
			let tR = hR;
			if (wR < hR) tR = wR;
			let nextScale = v._dm.baseScaleRate * tR;

			// 小数点第3位以下は切り捨て
			if (v._exp.onlyIntegerOfScale) {
				nextScale = sonbp.util.js.floor(nextScale, 2, 0.01);
			}

			var nextPoint = v._dm.getInitialDrawPoint(v._dm.pageIdxs, nextScale, sonbp.constant.pivot.CENTER_MIDDLE);

			v._dm.scaleRate = nextScale;
			v._dm.drawPoint = nextPoint;
			v._dm.reDraw();

			return true;
		} catch (e) {
			return sonbp.util.bp.andErrorNotice(false, v, "EXCEPTION", null, e);
		}
	}

	/**
	 * アイコンはアイテム矩形の角より外側にずらして描画するため、
	 * アイコン用にポイントの外側の座標を返す。
	 */
	export function getIconPoint(ifdto: ifbase.ifDto, points: sonbp.type.point[], pIdx: number, iconSize: number): sonbp.type.point {

		let _v = ifdto.bpView;
		let sz = iconSize - 1;

		let rad = sonbp.util.c2d.rad(45);
		let cpt = pIdx == 0 ?
					sonbp.util.c2d.getPointWithRotate(points[0], points[2], rad) :
					sonbp.util.c2d.getPointWithRotate(points[2], points[0], -rad);

		let result = sonbp.util.c2d.getExtendPoint(cpt, points[pIdx], sz);

		return result;
	}
}



